import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var Automatic = createSvgIcon(React__default.createElement("path", { d: "M10.9766 4.92188L7.97656 4.92188V2.92188H15.9766L15.9766 4.92188L12.9766 4.92188L12.9766 19.0781H15.9766L15.9766 21.0781H7.97656V19.0781H10.9766L10.9766 4.92188Z" }), 'Automatic');

export { Automatic };
